var _excluded = ["show", "maskClassName", "maskStyle", "onMaskClick", "children", "getContainer", "zIndex", "forceUpdateZIndex", "mask", "preventPointerEvent", "forceFixed", "wrapperClassName", "wrapperStyle", "animation", "wrapperRef", "style", "horizontal", "left", "right", "top", "bottom", "vertical"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { useCallback, useMemo, useRef, useState } from 'react';
import { useCombineRef, getZIndex } from '@okee-uikit/react-hooks';
import { useCSSEnterLeave } from '../../../hooks/animation';
import { RcMask } from '../../../hooks/mask';
import { RcPortal } from '../../../hooks/portal';

function getWrapperStyle(position) {
  return {
    position: position,
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    pointerEvents: 'none'
  };
}

function getPositionStyle(styleConf) {
  var preventPointerEvent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var style = {
    pointerEvents: preventPointerEvent ? 'none' : 'auto',
    position: 'absolute',
    zIndex: 2
  };

  switch (styleConf.horizontal) {
    case 'left':
      style.left = "".concat(styleConf.left || 0, "px");
      break;

    case 'right':
      style.right = "".concat(styleConf.right || 0, "px");
      break;

    case 'center':
      style.left = '50%';
      style.transform = 'translateX(-50%)';
      break;

    case 'dock':
      style.left = "".concat(styleConf.left || 0, "px");
      style.right = "".concat(styleConf.right || 0, "px");
      break;
  }

  switch (styleConf.vertical) {
    case 'top':
      style.top = "".concat(styleConf.top || 0, "px");
      break;

    case 'bottom':
      style.bottom = "".concat(styleConf.bottom || 0, "px");
      break;

    case 'center':
      style.top = '50%';
      style.transform = 'translateY(-50%)';
      break;

    case 'dock':
      style.top = "".concat(styleConf.top || 0, "px");
      style.bottom = "".concat(styleConf.bottom || 0, "px");
      break;
  }

  if (styleConf.horizontal === 'center' && styleConf.vertical === 'center') {
    style.transform = 'translate(-50%, -50%)';
  }

  return style;
}

var ACTIVE_POSTION = {
  fixed: true,
  absolute: true,
  relative: true
};

function getWrapperPosition(parent) {
  var _getComputedStyle = getComputedStyle(parent),
      parentPos = _getComputedStyle.position;

  if (parent === document.body) {
    return 'fixed';
  }

  if (!ACTIVE_POSTION[parentPos || '']) {
    parent.style.position = 'relative';
  }

  return 'absolute';
}

function RcDialogFC(props) {
  var _props$show = props.show,
      show = _props$show === void 0 ? false : _props$show,
      maskClassName = props.maskClassName,
      _props$maskStyle = props.maskStyle,
      maskStyle = _props$maskStyle === void 0 ? {} : _props$maskStyle,
      onMaskClick = props.onMaskClick,
      children = props.children,
      getContainer = props.getContainer,
      zIndex = props.zIndex,
      forceUpdateZIndex = props.forceUpdateZIndex,
      mask = props.mask,
      _props$preventPointer = props.preventPointerEvent,
      preventPointerEvent = _props$preventPointer === void 0 ? false : _props$preventPointer,
      _props$forceFixed = props.forceFixed,
      forceFixed = _props$forceFixed === void 0 ? false : _props$forceFixed,
      wrapperClassName = props.wrapperClassName,
      wrapperStyle = props.wrapperStyle,
      _props$animation = props.animation,
      animation = _props$animation === void 0 ? {
    disabled: true
  } : _props$animation,
      _props$wrapperRef = props.wrapperRef,
      wrapperRef = _props$wrapperRef === void 0 ? null : _props$wrapperRef,
      style = props.style,
      horizontal = props.horizontal,
      left = props.left,
      right = props.right,
      top = props.top,
      bottom = props.bottom,
      vertical = props.vertical,
      restProps = _objectWithoutProperties(props, _excluded);

  var styleConf = {
    horizontal: horizontal,
    left: left,
    right: right,
    top: top,
    bottom: bottom,
    vertical: vertical
  };
  var wrapperRefObject = useRef(null);
  var ref = useCombineRef(wrapperRef, wrapperRefObject);

  var _useState = useState('absolute'),
      _useState2 = _slicedToArray(_useState, 2),
      position = _useState2[0],
      setPosition = _useState2[1];

  var zIndexRandDep = useRef(0);
  zIndexRandDep.current = forceUpdateZIndex ? Math.random() : zIndexRandDep.current;
  var wrapperZIndex = useMemo(function () {
    return zIndex !== null && zIndex !== void 0 ? zIndex : getZIndex();
  }, [zIndex, show, zIndexRandDep.current]);
  var handlePortalUpdated = useCallback(function () {
    var _a;

    var container = (_a = getContainer === null || getContainer === void 0 ? void 0 : getContainer()) !== null && _a !== void 0 ? _a : document.body;

    if (container) {
      setPosition(forceFixed ? 'fixed' : getWrapperPosition(container));
    }
  }, [getContainer, forceFixed]);
  useCSSEnterLeave(wrapperRefObject, animation);

  if (typeof window === 'undefined') {
    return null;
  }

  return React.createElement(RcPortal, {
    getContainer: getContainer,
    onUpdated: handlePortalUpdated
  }, show && React.createElement("div", {
    ref: ref,
    className: wrapperClassName,
    style: _objectSpread(_objectSpread({
      zIndex: wrapperZIndex
    }, getWrapperStyle(position)), wrapperStyle)
  }, mask && React.createElement(RcMask, {
    show: true,
    className: maskClassName,
    style: _objectSpread(_objectSpread({}, maskStyle), {}, {
      zIndex: 1
    }),
    onClick: onMaskClick
  }), React.createElement("div", _objectSpread(_objectSpread({}, restProps), {}, {
    style: _objectSpread(_objectSpread({}, getPositionStyle(styleConf, preventPointerEvent)), style)
  }), children)));
}

export var RcDialog = React.forwardRef(function (props, ref) {
  return React.createElement(RcDialogFC, _objectSpread(_objectSpread({}, props), {}, {
    wrapperRef: ref
  }));
});